import { call, put, takeLatest, all } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as types from './actionTypes';
import { post } from "../../../../helpers/api_helper";
import { fetchDeductionFailure, fetchDeductionSuccess, fetchMonthlyDeductionSuccess, fetchMonthlyDeductionFailure } from './actions';

// Fetch Monthly Deduction
function* fetchMonthlyDeductionSaga(action) {  
  try {    
    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_FETCH_MONTHLY_DEDUCTION,action.payload); // Replace with actual endpoint
    // if (!response || response.status !== 'success') {
    //   throw new Error(response?.message || 'Failed to fetch MonthlyDeduction!');
    // }
    yield put(fetchMonthlyDeductionSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchMonthlyDeductionFailure(error.message));
  }
}

// 💾 Save Saga
function* saveMonthlyDeductionSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_SAVE_MONTHLY_DEDUCTION, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save MonthlyDeduction!');
    }

    yield put({ type: types.PAYROLL_DEDUCTION_SAVE_MONTHLY_DEDUCTION_SUCCESS, payload: response });
    Swal.fire('Success', 'Saved successfully!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.PAYROLL_DEDUCTION_SAVE_MONTHLY_DEDUCTION_FAILURE, payload: error });
  }
}

// Remove Saga
function* removeMonthlyDeductionSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to save MonthlyDeduction!');
    }

    yield put({ type: types.PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION_SUCCESS, payload: response });
    Swal.fire('Success', 'Deleted successfully!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION_FAILURE, payload: error });
  }
}

// 🔄 Change Status Saga
function* changeMonthlyDeductionStatusSaga(action) {
  try {

    const response = yield call(post, process.env.REACT_APP_PAYROLL_DEDUCTION_CHANGE_MONTHLY_DEDUCTION_STATUS, action.payload);

    if (!response || response.status !== 'success') {
      throw new Error(response?.message || 'Failed to change status!');
    }

    yield put({ type: types.PAYROLL_DEDUCTION_CHANGE_MONTHLY_DEDUCTION_STATUS_SUCCESS, payload: response });
    Swal.fire('Success', 'Status updated!', 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while updating status!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.PAYROLL_DEDUCTION_CHANGE_MONTHLY_DEDUCTION_STATUS_FAILURE, payload: error });
  }
}

function* deductionGetTemplateSaga(action) {
  try {
     const response = yield call(post, process.env.REACT_APP_FETCH_FIXED_DEDUCTION_GETTEMPLATE, action.payload);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to download template!");
    }

    // ✅ Trigger file download
    if (response?.data) {
      const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${response.data}`; // full URL
      const link = document.createElement("a");
      link.href = fileUrl;
      link.download = "EmployeePunchTemplate.xlsx"; // optional filename
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

    Swal.fire("Success", "Template downloaded successfully!", "success");
    yield put({ type: types.PAYROLL_DEDUCTION_MONTHLY_TEMPLATE_SUCCESS, payload: response });
  } catch (error) {
    Swal.fire("Error", error.message, "error");
    yield put({ type: types.PAYROLL_DEDUCTION_MONTHLY_TEMPLATE_FAILURE, payload: error });
  }
}

function* importMonthlyDeductionSaga(action) {
  try {
    const response = yield call(post, process.env.REACT_APP_SAVE_MONTHLY_DEDUCTIONS_IMPORT, action.payload);

    if (!response || response.status !== 'success') { throw new Error(response?.message || 'Failed to save MonthlyDeduction!'); }

    yield put({ type: types.PAYROLL_DEDUCTION_IMPORT_MONTHLY_SUCCESS, payload: response });
    Swal.fire('Success', response?.message, 'success');
  } catch (error) {
    Swal.fire({
      title: 'Error',
      text: error.message || 'Something went wrong while saving!',
      icon: 'error',
      confirmButtonText: 'OK',
    });

    yield put({ type: types.PAYROLL_DEDUCTION_IMPORT_MONTHLY_FAILURE, payload: error });
  }
}

// 🔄 Root Saga
export default function* monthlyDeductionSaga() {
  yield all([
    takeLatest(types.PAYROLL_DEDUCTION_FETCH_MONTHLY_DEDUCTION, fetchMonthlyDeductionSaga),
    takeLatest(types.PAYROLL_DEDUCTION_SAVE_MONTHLY_DEDUCTION, saveMonthlyDeductionSaga),
    takeLatest(types.PAYROLL_DEDUCTION_REMOVE_MONTHLY_DEDUCTION, removeMonthlyDeductionSaga),
    takeLatest(types.PAYROLL_DEDUCTION_CHANGE_MONTHLY_DEDUCTION_STATUS, changeMonthlyDeductionStatusSaga),
    takeLatest(types.PAYROLL_DEDUCTION_MONTHLY_TEMPLATE, deductionGetTemplateSaga),
    takeLatest(types.PAYROLL_DEDUCTION_IMPORT_MONTHLY, importMonthlyDeductionSaga),
  ]);
}
